module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "final-project"
  }, [_c('div', {
    staticClass: "demo-reel-submission"
  }, [_c('dam-submission', {
    attrs: {
      "type": 'demoReel',
      "demoReel": _vm.latestSubmission
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.projects) ? _c('ul', {
    staticClass: "projects"
  }, _vm._l((_vm.projects), function(project, $index) {
    return _c('li', [_c('div', {
      staticClass: "table-row"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-plus",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedProject === project.id ? _vm.selectedProject = null : _vm.selectedProject = project.id
        }
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("shortDate")(project.createdAt)))]), _vm._v(" "), _c('div', [(_vm.hasFeedback(project)) ? _c('img', {
      staticClass: "play active",
      attrs: {
        "src": require("../assets/img/play-button-small-green.png")
      },
      on: {
        "click": function($event) {
          _vm.playFeedback(_vm.feedbackUrl(project))
        }
      }
    }) : _c('img', {
      staticClass: "play",
      attrs: {
        "src": require("../assets/img/play-button-small-grey.png")
      }
    })]), _vm._v(" "), (project.passed == null) ? _c('div', [_vm._v("                               \n                                Waiting For Feedback\n                            ")]) : _vm._e(), _vm._v(" "), (project.passed === false) ? _c('div', {
      staticClass: "fixes-needed"
    }, [_vm._v("\n                                Fixes Required\n                            ")]) : _vm._e(), _vm._v(" "), (project.passed === true) ? _c('div', {
      staticClass: "passed"
    }, [_vm._v("\n                                Passed\n                            ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedProject === project.id) ? _c('div', {
      staticClass: "project"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "reel"
    }, [_c('video', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": project.demoReelUrl
      }
    })])]), _vm._v(" "), (project.stillRenders && project.stillRenders.length > 0) ? _c('ul', {
      staticClass: "still-renders"
    }, [_vm._l((project.stillRenders), function(render, $index) {
      return _c('li', [(render.includes('amazonaws')) ? _c('a', {
        attrs: {
          "href": render,
          "target": "_blank"
        }
      }, [_vm._v("Image " + _vm._s($index))]) : _c('a', {
        attrs: {
          "href": 'https://drive.google.com/uc?export=view&id=' + render,
          "target": "_blank"
        }
      }, [_vm._v("Image " + _vm._s($index))])])
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (project.extraVideos.length === 0) ? _c('li', [_vm._v("No additional videos")]) : _vm._e(), _vm._v(" "), _vm._l((project.extraVideos), function(asset, $index) {
      return _c('li', [_c('a', {
        attrs: {
          "href": asset.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(asset.descriptor))])])
    })], 2) : _vm._e()]), _vm._v(" "), (project.comments) ? _c('div', {
      staticClass: "student-comments"
    }, [_c('label', [_vm._v("Your Comments")]), _vm._v("\n                                " + _vm._s(project.comments) + "\n                            ")]) : _vm._e(), _vm._v(" "), (project.final_feedback && project.final_feedback.comments) ? _c('div', {
      staticClass: "feedback-comments"
    }, [_c('label', [_vm._v("Director's Comments")]), _vm._v("\n                                " + _vm._s(project.final_feedback.comments) + "\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((project.final_feedbacks), function(final_feedback) {
      return (project.final_feedbacks) ? _c('div', {
        staticClass: "feedback-comments"
      }, [(final_feedback.comments) ? _c('div', [_c('label', [_vm._v("Director's Comments")]), _vm._v("\n                                    " + _vm._s(final_feedback.comments) + "\n                                ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (project.passed === true && project.enrollment && project.enrollment.program && project.enrollment.program.venue === 'online') ? _c('div', {
      staticClass: "diploma"
    }, [((_vm.localStorage.roles.includes('Student') && _vm.localStorage.transitioned != 'true')) ? _c('div', [_c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                                        Digital Credentials (dark)\n                                    ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '_print.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                                        Digital Credentials (light)\n                                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div')], 2) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying === true),
      expression: "feedbackPlaying===true"
    }],
    staticClass: "feedback-lightbox",
    on: {
      "click": function($event) {
        _vm.stopFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('video-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying),
      expression: "feedbackPlaying"
    }],
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Previous Submissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('h4', {
    staticClass: "bold"
  }, [_vm._v("Additional Videos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-389eb126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinalProject.vue
// module id = 2015
// module chunks = 2